<template>
  <div>
    <div class="flex flex-wrap w-full items-center justify-center" v-if="!isMfaSkipped">
      <div class="flex flex-wrap w-full items-center justify-start">
        <div class="flex-inline w-full items-center text-left hireful-font-domus text-gray-400 py-4">
          <strong>Multi-factor authentication</strong> adds an extra layer of security to your account by sending a code to your phone which will be used in the login process.
        </div>
        <div class="flex-inline w-full items-center text-left hireful-font-domus text-gray-400 py-4">
          Would you like to protect your account by enabled <strong>MFA</strong> now?
        </div>
        <div class="flex w-full items-center text-left hireful-font-domus text-gray-400 py-4">
          This will take approximately one minute
        </div>

        <div class="flex w-full items-center justify-center py-4">
          <loader v-if="loading" />
          <div class="flex flex-wrap w-full items-center justify-center" v-else>
            <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg" @click="setupMfa()" >
              Set up now
            </button>
            <div class="flex w-full items-center justify-center py-4">
              <span class="hireful-font-semibold text-gray-400 cursor-pointer" @click="showSkipMfaConfirmation()">
                Skip
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap w-full items-center justify-center" v-else>
      <div class="flex-inline w-full items-center text-left hireful-font-domus text-gray-400 py-4">
        In case you change your mind, <strong>Multi-factor authentication (MFA)</strong> can be enabled at any time from your personal user settings within the system.
      </div>
      <div class="flex w-full items-center text-left hireful-font-domus text-gray-400 py-4">
        You can access your personal user settings by clicking your name in the top right corner of the system and clicking the cog icon.
      </div>
      <div class="flex-inline w-full items-center text-left hireful-font-domus text-gray-400 py-4">
        We will no longer prompt you to set up <strong>MFA</strong> when you login.
      </div>

      <div class="flex w-full items-center justify-center py-4">
        <loader v-if="loading" />
        <div class="flex flex-wrap w-full items-center justify-center" v-else>
          <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg" @click="skipMfa()" >
            Proceed to login
          </button>
          <div class="flex w-full items-center justify-center py-4">
            <span class="hireful-font-semibold text-gray-400 cursor-pointer" @click="resetSkipMfa()">
              Back
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/loader'

export default {
  name: 'enableMfa',
  components: {
    loader
  },
  data () {
    return {
      loading: false,
      isMfaSkipped: false
    }
  },
  mounted () {
    const vm = this
    vm.$emit('setPageTitle', 'Set up multi-factor authentication')
  },
  methods: {
    setupMfa () {
      const vm = this
      vm.$emit('setupMfa', true)
    },
    showSkipMfaConfirmation () {
      const vm = this
      vm.$emit('setPageTitle', 'Multi-factor authentication setup skipped')
      vm.isMfaSkipped = true
    },
    resetSkipMfa () {
      const vm = this
      vm.$emit('setPageTitle', 'Set up multi-factor authentication')
      vm.isMfaSkipped = false
    },
    skipMfa () {
      const vm = this
      vm.$emit('skipMfa', true)
    }
  }
}
</script>

<style>

</style>
